let last_page = null; // Variable to store the last visited page

jQuery(document).on('gform_post_render', function(event, form_id, current_page){

  // if aludo-form div exists
  if (document.querySelector('.aludo-form')) {

    set_min_counts();
    aludo_form_validate_count();
    // listenCheckboxChange();

    // Check if the current page is 1 and the last visited page was 2
    if (current_page == 1 && last_page == 2) {
      restore_aludo_fields();
    }

    // Update the last visited page
    last_page = current_page;

    // Handle form submission to ensure the saved data is restored
    jQuery('#gform_submit_button_22').on('click', function() {
      restore_aludo_fields();
    });

    // Save form data on change
    jQuery('#field_22_13').on('input change', 'input, select, textarea', function() {
      save_aludo_fields();
    });


    // Save number input value on change
    jQuery('#field_22_13').on('change', 'input[type="number"]', function() {

      console.log("asd");

      var value = jQuery(this).val();
      jQuery(this).attr('value', value);
      save_aludo_fields();
    });

    // Save checkbox status on change
    jQuery('#field_22_13').on('change', 'input[type="checkbox"]', function() {
      const checkbox = jQuery(this);
      const parentGroup = checkbox.closest('.gfield_list_group');

      // Get min value from last list item
      const minValue = parentGroup.find('.gfield_list_13_cell4 input').val();
      const value = checkbox.is(':checked') ? minValue : 0;

      // Set value of the input inside gfield_list_13_cell3
      parentGroup.find('.gfield_list_13_cell3 input').attr('value', value);
      parentGroup.find('.gfield_list_13_cell3 input')[0].value = value;

      // Save checkbox status
      checkbox.prop('checked', checkbox.is(':checked'));
      if (checkbox.is(':checked')) {
        checkbox.attr('checked', 'checked');
      } else {
        checkbox.removeAttr('checked');
      }

      save_aludo_fields();
    });

  }

});

function save_aludo_fields() {
  const listElement = jQuery('#field_22_13');
  const clonedElement = listElement.clone(true, true); // Clone the element with data and events
  const htmlString = clonedElement.prop('outerHTML'); // Get the outer HTML of the cloned element

  //console.log('Form data to be saved:', htmlString);
  localStorage.setItem('aludoFormData', htmlString);
}

function restore_aludo_fields() {
  const savedHtmlString = localStorage.getItem('aludoFormData');

  if (savedHtmlString) {
    //console.log('Restoring form data:', savedHtmlString);
    const listElement = jQuery('#field_22_13');
    const newElement = jQuery(savedHtmlString); // Create a jQuery object from the saved HTML string
    listElement.replaceWith(newElement); // Replace the current element with the new element
  }
}


// validate number input min values on change
function aludo_form_validate_count() {

  // validation message for count input field if number too low
  const aludoFormCountM = document.querySelectorAll('.aludo-form input[type="number"]');

  // sync values of first two rows
  if (aludoFormCountM.length >= 2) {
    // Add event listener to the first input field
    aludoFormCountM[0].addEventListener("input", (event) => {
      // Update the value of the second input field
      aludoFormCountM[1].value = event.target.value;
    });
  }

  for (let i = 0; i < aludoFormCountM.length; i++) {

    if (typeof(aludoFormCountM[i]) != 'undefined' && aludoFormCountM[i] != null) {
      aludoFormCountM[i].addEventListener("input", (event) => {

        const input = event.target;
        const validity = input.validity.rangeUnderflow;
        const value_min = input.getAttribute("min");

        if (validity == true) {
          input.setCustomValidity(theme_strings.profile_form_count_error + value_min);
        } else {
          input.setCustomValidity("");
        }

        input.reportValidity();
      });
    }

    if (typeof(aludoFormCountM[i]) != 'undefined' && aludoFormCountM[i] != null) {
      aludoFormCountM[i].addEventListener("change", (event) => {

        const input = event.target;
        const validity = input.validity.rangeUnderflow;
        const value_min = input.getAttribute("min");

        if (validity == true) {
          input.value = value_min;
        }
      });
    }
  }
}

// Listen for checkbox change and set input value to 100 or 0
// function listenCheckboxChange() {
//   const checkboxes = document.querySelectorAll('.aludo-form .gfield_list_group input[type="checkbox"]');

//   checkboxes.forEach(checkbox => {
//     checkbox.addEventListener('change', () => {
//       const parentGroup = checkbox.closest('.gfield_list_group');

//       // get min value from last list item
//       const minValue = parentGroup.querySelector('.gfield_list_13_cell4 input').value;

//       const value = checkbox.checked ? minValue : 0;

//       const numberInputs = parentGroup.querySelectorAll('input[type="number"]');
//       numberInputs.forEach(input => {
//         input.value = value;
//       });
//     });
//   });

//   save_aludo_fields();
// }


function set_min_counts() {

  // loop through all gfield_list_group elements in aludo-form div
  const aludoFormGroups = document.querySelectorAll('.aludo-form .gfield_list_group');

    aludoFormGroups.forEach(group => {

      // get value of gfield_list_13_cell4 input field
      const min_value = group.querySelector('.gfield_list_13_cell4 input').value;

      // set min_value to min attribute in gfield_list_13_cell3 input field
      const input = group.querySelector('.gfield_list_13_cell3 input');
      input.setAttribute('min', min_value);
    });

};
